import { Empty, Image, Masonry } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type CollectionFileFragment } from "../gql/generated/graphqlSchema.tsx";
import { ImageFile } from "./ImageFile.tsx";

const renderFile = (itemInfo: { data: CollectionFileFragment }) => <ImageFile file={itemInfo.data} />;

type FileCollectionGalleryProps = {
  readonly files: readonly CollectionFileFragment[];
};

export const FileCollectionGallery = ({ files }: FileCollectionGalleryProps) => {
  const { t } = useTranslation();

  const masonryItems = useMemo(() => files.map((file) => ({ key: file.id, data: file })), [files]);

  if (files.length === 0) {
    return <Empty description={t("ingredients.photos.empty")} />;
  }

  return (
    <Image.PreviewGroup>
      <Masonry columns={{ xs: 2, sm: 3, md: 4, lg: 5 }} gutter={[8, 8]} itemRender={renderFile} items={masonryItems} />
    </Image.PreviewGroup>
  );
};
